export enum TutorialElement {
  Characters = "Characters",
  Panels = "Panels",
  Tunnels = "Tunnels",
}